import { SourcingService } from 'api-clients/monolith';

/* eslint-disable camelcase */
export interface ValidateSourcingPurchasesParams {
  channel_slug: string;
  start_date: string;
  end_date: string | null;
  opening_ids: string[];
  is_vonq_channel: boolean | null;
  vonq_product_id: string | null;
  vonq_contract_id?: string | null;
  remote_channel_id?: string | null;
  posting_requirements?: Record<string, string | string[]> | null;
  direct_apply_questionnaire?: { facet: string } | null;
}
/* eslint-enable camelcase */

export function validateSourcingPurchases(
  params: ValidateSourcingPurchasesParams,
) {
  return SourcingService.postInternalApiSourcingSourcingPurchasesValidateSourcingPurchases(
    params,
  );
}
